import React, { Component } from 'react'
import SearchBar from './SearchBar'
import Table from './Table'
import { Badge } from 'hljd'
import Store from './store'
import style from './style.module.less'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import { Action } from 'hljd'

const Item = Action.Item

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
    const { tab } = props.location.query
    tab && this.store.initialTab(tab)
  }

  render() {
    const { activeTab, un_read, changeTab } = this.store

    return (
      <HeaderView title="体验店推荐">
        <div style={{ paddingTop: 20 }}>
          <SearchBar store={this.store} />
          <div className={style.tabs}>
            <Action onChange={changeTab} active={activeTab}>
              <Item value="all">全部</Item>
              <Item value="unread">
                <span>
                  待查看{' '}
                  {+un_read.unread_count !== 0 && (
                    <Badge
                      style={{ background: '#ff5c5c' }}
                      count={un_read.unread_count}
                    />
                  )}
                </span>
              </Item>
              <Item value="read">
                <span>
                  已查看{' '}
                  {+un_read.read_count !== 0 && (
                    <Badge
                      style={{ background: '#508cee' }}
                      count={un_read.read_count}
                    />
                  )}
                </span>
              </Item>
              <Item value="is_come">
                <span>
                  已到店{' '}
                  {+un_read.come_count !== 0 && (
                    <Badge
                      style={{ background: '#508cee' }}
                      count={un_read.come_count}
                    />
                  )}
                </span>
              </Item>
              <Item value="formed">
                <span>
                  已成单{' '}
                  {+un_read.formed_count !== 0 && (
                    <Badge
                      style={{ background: '#508cee' }}
                      count={un_read.formed_count}
                    />
                  )}
                </span>
              </Item>
              <Item value="expired">已过期</Item>
              <Item value="follow-failed">跟进失败</Item>
            </Action>
            <Table store={this.store} />
          </div>
        </div>
      </HeaderView>
    )
  }
}
